import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import SureBuyStepBuy_1 from "../sureSteps/buy/step_1";
import SureBuyStepBuy_2 from "../sureSteps/buy/step_2";
import SureBuyStepBuy_3 from "../sureSteps/buy/step_3";
import SureBuyStepBuy_4 from "../sureSteps/buy/step_4";
import SureBuyStepBuy_5 from "../sureSteps/buy/step_5";

const getShureBuySteps = (
  data: IFillDataWizardBuy,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeView: boolean;
  }
) => {
  // если знает что хочет преобрести и не соберается продавать квартиру

  const {
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeCommunication,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeView,
  } = disabledAndPrev;

  return [
    <SureBuyStepBuy_1
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <SureBuyStepBuy_2
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <SureBuyStepBuy_3
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <SureBuyStepBuy_4
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <SureBuyStepBuy_5 data={data} />,
  ];
};

export default getShureBuySteps;
